import { render, staticRenderFns } from "./ExpandQuestion.vue?vue&type=template&id=8722a65a&lang=html"
import script from "./ExpandQuestion.vue?vue&type=script&lang=js"
export * from "./ExpandQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports